import React from 'react';

const ChevronDown = ({
  stroke = "white",
  className,
  style
}) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    width: "12",
    height: "12",
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className,
    style: { ...style, overflow: "visible" }
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M3 4.5L6 7.5L9 4.5",
      stroke,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  )
);
ChevronDown.displayName = "Icons.ChevronDown";

export { ChevronDown };
//# sourceMappingURL=ChevronDown.js.map
